// extracted by mini-css-extract-plugin
export default {"card":"EventCard_card__sgPjF"};